export default "__VITE_ASSET__Ba3d9p1F__"